import React from "react";
import Terms from "../Components/Terms/Terms";
import Purpose from "../Components/Purpose/Purpose";
import Privacy from "../Components/Privacy/Privacy";
import DataController from "../Components/DataController/DataController";
import Information from "../Components/Information/Information";
import Processor from "../Components/Processor/Processor";
import Record from "../Components/Record/Record";
import Disclosure from "../Components/Disclosure/Disclosure";
import Permission from "../Components/Permission/Permission";
import Change from "../Components/Change/Change";
import Access from "../Components/Access/Access";
import Analysis from "../Components/Analysis/Analysis";
import Marketing from "../Components/Marketing/Marketing";
import Collection from "../Components/Collection/Collection";
import Questions from "../Components/Questions/Questions";
import Complaint from "../Components/Complaint/Complaint";

export const menuItems = [
  {
    id: 0,
    title: "Formål",
    src: <Terms />,
  },
  {
    id: 1,
    title: "Brukerkonto, identifisering og sikkerhet",
    src: <Purpose />,
  },
  {
    id: 2,
    title: "Hvorfor lagrer vi data om deg?",
    src: <Privacy />,
  },
  {
    id: 3,
    title: "Behandlingsansvarlig",
    src: <DataController />,
  },
  {
    id: 4,
    title: "Opplysninger om behandlingsansvarlig",
    src: <Information />,
  },
  {
    id: 5,
    title: "Disse dataene registreres og lagres",
    src: <Record />,
  },
  {
    id: 6,
    title: "Bruk av databehandlere",
    src: <Processor />,
  },
  {
    id: 7,
    title: "Utlevering av personopplysninger",
    src: <Disclosure />,
  },
  {
    id: 8,
    title: "Tillatelse til tilganger på telefonen",
    src: <Permission />,
  },
  {
    id: 9,
    title: "Endringer i brukervilkår",
    src: <Change />,
  },
  {
    id: 10,
    title: "Innsyn, retting og sletting av app og personopplysninger",
    src: <Access />,
  },
  {
    id: 11,
    title: "Analyse, statistikk og kommunikasjon",
    src: <Analysis />,
  },
  {
    id: 12,
    title: "GMG kan sende markedsføring til deg",
    src: <Marketing />,
  },
  {
    id: 13,
    title: "Innhenting av data og deling med tredjeparter",
    src: <Collection />,
  },
  {
    id: 14,
    title: "Har du spørsmål om Bilista?",
    src: <Questions />,
  },

  {
    id: 15,
    title: "Klage til Datatilsynet",
    src: <Complaint />,
  },
];
